import { render, staticRenderFns } from "./DirectDebitAccounts.vue?vue&type=template&id=33c557f4"
import script from "./DirectDebitAccounts.vue?vue&type=script&lang=js"
export * from "./DirectDebitAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports